/* eslint-disable no-underscore-dangle */

// Helper to create initial field state
export const createFieldState = (control, controlValue) => ({
  name: control.fieldName,
  clean_value: controlValue,
  value: controlValue,
  touched: false,
  dirty: false,
  valid: !control?.validators?.length || control.validators.every((v) => !v(controlValue)),
  errors: control?.validators?.length
    ? control.validators.map((validator) => validator(controlValue)).filter((error) => !!error)
    : [],
  validators: control.validators ?? [],
  sanitizers: control.sanitizers ?? [],
  placeholder: control.placeholder ?? '',
  label: control.label ?? '',
  description: control.description ?? '',
});

// Initialize field groups and return initial instances and fields
export const initializeFieldGroups = (fieldGroups, createFieldStateFn) => {
  const initialGroupInstances = {};
  const groupFields = {};

  Object.keys(fieldGroups).forEach((groupName) => {
    const groupConfig = fieldGroups[groupName];
    const initialData = groupConfig.initialData || [];
    const instanceCount = Math.max(
      groupConfig.minInstances || 0,
      initialData.length,
    );

    initialGroupInstances[groupName] = [];

    for (let i = 0; i < instanceCount; i += 1) {
      const instanceId = crypto.randomUUID();
      initialGroupInstances[groupName].push(instanceId);

      // Add fields for this instance
      groupConfig.schema.forEach((fieldSchema) => {
        const fieldName = `${groupName}_${instanceId}_${fieldSchema.fieldName}`;
        const initialValue = initialData[i]?.[fieldSchema.fieldName] ?? fieldSchema.value;
        const fieldState = createFieldStateFn(fieldSchema, initialValue);

        groupFields[fieldName] = {
          ...fieldState,
          name: fieldName, // Override with the full field name
          _groupName: groupName,
          _groupId: instanceId,
          _fieldKey: fieldSchema.fieldName,
        };
      });
    }
  });

  return { initialGroupInstances, groupFields };
};
